import { Link } from "react-router-dom";
import { festival } from "../data/festival";
import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import Button from "../components/Button";
import { IconArrow } from "../components/icons";
import styles from "./About.module.css";

const aboutSubNav = [
  { label: "About", path: "/about", end: true },
  { label: "Venue Info", path: "/about/venue" },
  { label: "FAQ", path: "/about/faq" },
  { label: "SFMA", path: "/about/sfma" },
  { label: "Press", path: "/about/press" },
  { label: "Contact", path: "/about/contact" },
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About the festival"
        title="A Volunteer-Run Music Festival on the Rio Grande"
        lede="Camping, dancing, and music education — three days that fund a year of instruments and free lessons for kids in rural Colorado."
        image="/photos/festival-3.jpg"
      />
      <SubNav items={aboutSubNav} />

      <Page>
        <div className={styles.intro}>
          <div className={styles.body}>
            <p className={styles.lead}>
              Rhythms on the Rio is a multi-day camping music festival staged on the
              banks of the mighty Rio Grande, just outside Del Norte, Colorado. It is
              the flagship benefit event of the <strong>South Fork Music Association</strong>,
              a 100% volunteer nonprofit that uses ticket revenue to fund music
              education for children across the San Luis Valley.
            </p>
            <p>
              The festival is family-friendly, primitive-camped, and proudly
              independent. There are no naming-rights deals, no corporate stages —
              just a single mainstage, a quiet family camping field, walk-in tent
              spots in the cottonwoods, and a river running directly across the
              street. We open Thursday with early entry, run through Sunday evening,
              and ask every guest to leave it cleaner than they found it.
            </p>
            <p>
              When you buy a ticket, you're not just paying for music — you're
              underwriting an instrument in the hands of a child who would otherwise
              never own one.
            </p>
            <Button to="/about/sfma" variant="dark" size="md">
              Meet SFMA
            </Button>
          </div>
          <aside className={styles.facts}>
            <h3 className={styles.factsH}>Quick Facts</h3>
            <dl className={styles.dl}>
              <dt>Dates</dt><dd>{festival.dates}</dd>
              <dt>Location</dt><dd>{festival.address}</dd>
              <dt>Format</dt><dd>3-day camping festival, single mainstage</dd>
              <dt>Stages</dt><dd>1 mainstage + late-night collaborations</dd>
              <dt>Camping</dt><dd>Walk-in, car, group, RV (primitive)</dd>
              <dt>Beneficiary</dt><dd>South Fork Music Association</dd>
            </dl>
          </aside>
        </div>

        <h2 className={styles.h2}>Explore</h2>
        <div className={styles.cardGrid}>
          <Link className={styles.card} to="/about/venue">
            <h3>Venue & Camping</h3>
            <p>Gates, camping options, river access, what you can and can't bring.</p>
            <span className={styles.cardArrow}>Read more <IconArrow /></span>
          </Link>
          <Link className={styles.card} to="/about/faq">
            <h3>FAQ</h3>
            <p>The questions you've been quietly wondering about — dogs, ice, generators, fires.</p>
            <span className={styles.cardArrow}>Read more <IconArrow /></span>
          </Link>
          <Link className={styles.card} to="/about/sfma">
            <h3>South Fork Music Association</h3>
            <p>The 501(c)(3) behind the festival and where every dollar goes.</p>
            <span className={styles.cardArrow}>Read more <IconArrow /></span>
          </Link>
          <Link className={styles.card} to="/about/press">
            <h3>Press</h3>
            <p>What Relix, Westword, 5280, and Festy GoNuts have said about us.</p>
            <span className={styles.cardArrow}>Read more <IconArrow /></span>
          </Link>
          <Link className={styles.card} to="/about/contact">
            <h3>Contact</h3>
            <p>The right inbox for volunteers, sponsors, vendors, press, and artists.</p>
            <span className={styles.cardArrow}>Read more <IconArrow /></span>
          </Link>
          <Link className={styles.card} to="/lineup/previous">
            <h3>Previous Lineups</h3>
            <p>Every poster from every year — old friends, old crowds, old dust.</p>
            <span className={styles.cardArrow}>Read more <IconArrow /></span>
          </Link>
        </div>
      </Page>
    </>
  );
}
